<div class="recover-page">
  <div class="recover-container">
    <div class="recover-card">
      <div class="recover-header">
        <h1>{{ 'recoverPassword.title' | translate }}</h1>
        <div class="steps-indicator">
          <div class="step" [class.active]="currentStep() === 1" [class.completed]="currentStep() > 1">
            <div class="step-number">1</div>
            <div class="step-label">{{ 'recoverPassword.stepEmail' | translate }}</div>
          </div>
          <div class="step-line" [class.completed]="currentStep() > 1"></div>
          <div class="step" [class.active]="currentStep() === 2" [class.completed]="currentStep() > 2">
            <div class="step-number">2</div>
            <div class="step-label">{{ 'recoverPassword.stepCode' | translate }}</div>
          </div>
          <div class="step-line" [class.completed]="currentStep() > 2"></div>
          <div class="step" [class.active]="currentStep() === 3">
            <div class="step-number">3</div>
            <div class="step-label">{{ 'recoverPassword.stepPassword' | translate }}</div>
          </div>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-message">
          {{ errorMessage() }}
        </div>
      }

      @if (successMessage()) {
        <div class="success-message">
          {{ successMessage() }}
        </div>
      }

      <!-- Step 1: Email -->
      @if (currentStep() === 1) {
        <form (ngSubmit)="onSendCode()" class="recover-form">
          <p class="step-description">{{ 'recoverPassword.step1Description' | translate }}</p>

          <div class="form-group">
            <label for="email">{{ 'recoverPassword.emailLabel' | translate }}</label>
            <input
              type="email"
              id="email"
              [value]="email()"
              (input)="email.set($any($event.target).value)"
              [placeholder]="'recoverPassword.emailPlaceholder' | translate"
              [disabled]="isLoading()"
              required
              autocomplete="email"
            />
          </div>

          <button
            type="submit"
            class="btn-primary"
            [disabled]="isLoading()"
          >
            @if (isLoading()) {
              <mat-spinner diameter="20" color="accent"></mat-spinner>
              {{ 'recoverPassword.sending' | translate }}
            } @else {
              {{ 'recoverPassword.sendCode' | translate }}
            }
          </button>
        </form>
      }

      <!-- Step 2: Verification Code -->
      @if (currentStep() === 2) {
        <form (ngSubmit)="onVerifyCode()" class="recover-form">
          <p class="step-description">{{ 'recoverPassword.step2Description' | translate }} {{ email() }}</p>

          <div class="form-group">
            <label for="code">{{ 'recoverPassword.codeLabel' | translate }}</label>
            <input
              type="text"
              id="code"
              [value]="verificationCode()"
              (input)="onCodeInput($event)"
              (keypress)="onlyNumbers($event)"
              [placeholder]="'recoverPassword.codePlaceholder' | translate"
              [disabled]="isLoading()"
              required
              maxlength="6"
              inputmode="numeric"
              pattern="[0-9]*"
            />
          </div>

          <div class="button-group">
            <button
              type="button"
              class="btn-secondary"
              (click)="goBack()"
              [disabled]="isLoading()"
            >
              {{ 'recoverPassword.back' | translate }}
            </button>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="isLoading()"
            >
              @if (isLoading()) {
                <mat-spinner diameter="20" color="accent"></mat-spinner>
                {{ 'recoverPassword.verifying' | translate }}
              } @else {
                {{ 'recoverPassword.confirm' | translate }}
              }
            </button>
          </div>
        </form>
      }

      <!-- Step 3: New Password -->
      @if (currentStep() === 3) {
        <form (ngSubmit)="onResetPassword()" class="recover-form">
          <p class="step-description">{{ 'recoverPassword.step3Description' | translate }}</p>

          <div class="form-group">
            <label for="newPassword">{{ 'recoverPassword.newPasswordLabel' | translate }}</label>
            <div class="password-input-wrapper">
              <input
                [type]="showPassword() ? 'text' : 'password'"
                id="newPassword"
                [value]="newPassword()"
                (input)="newPassword.set($any($event.target).value)"
                [placeholder]="'recoverPassword.passwordPlaceholder' | translate"
                [disabled]="isLoading()"
                required
                autocomplete="new-password"
              />
              <button
                type="button"
                class="toggle-password"
                (click)="togglePasswordVisibility()"
                [disabled]="isLoading()"
              >
                {{ showPassword() ? '👁️' : '👁️‍🗨️' }}
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="confirmPassword">{{ 'recoverPassword.confirmPasswordLabel' | translate }}</label>
            <div class="password-input-wrapper">
              <input
                [type]="showConfirmPassword() ? 'text' : 'password'"
                id="confirmPassword"
                [value]="confirmPassword()"
                (input)="confirmPassword.set($any($event.target).value)"
                [placeholder]="'recoverPassword.passwordPlaceholder' | translate"
                [disabled]="isLoading()"
                required
                autocomplete="new-password"
              />
              <button
                type="button"
                class="toggle-password"
                (click)="toggleConfirmPasswordVisibility()"
                [disabled]="isLoading()"
              >
                {{ showConfirmPassword() ? '👁️' : '👁️‍🗨️' }}
              </button>
            </div>
          </div>

          <div class="button-group">
            <button
              type="button"
              class="btn-secondary"
              (click)="goBack()"
              [disabled]="isLoading()"
            >
              {{ 'recoverPassword.back' | translate }}
            </button>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="isLoading()"
            >
              @if (isLoading()) {
                <mat-spinner diameter="20" color="accent"></mat-spinner>
                {{ 'recoverPassword.saving' | translate }}
              } @else {
                {{ 'recoverPassword.changePassword' | translate }}
              }
            </button>
          </div>
        </form>
      }

      <div class="recover-footer">
        <a routerLink="/login" class="back-link">{{ 'recoverPassword.backToLogin' | translate }}</a>
      </div>
    </div>
  </div>
</div>
